import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "../../lib/utils";

const textareaVariants = cva(
	"flex min-h-[80px] w-full rounded-md border border-input bg-background text-textarea-foreground ring-offset-background placeholder:text-neutral-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neutral-950 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 dark:border-neutral-800 dark:bg-neutral-950 dark:ring-offset-neutral-950 dark:placeholder:text-neutral-400 dark:focus-visible:ring-neutral-300",
	{
		variants: {
			size: {
				default: "px-3 py-2 text-base md:text-sm",
				lg: "px-4 py-3 text-lg",
			},
		},
		defaultVariants: {
			size: "default",
		},
	},
);

/** Props for {@link Textarea}. `size` controls padding/text size; `lg` matches the legacy jux-next field. */
export type TextareaProps = Omit<React.ComponentProps<"textarea">, "size"> &
	VariantProps<typeof textareaVariants>;

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
	({ className, size, ...props }, ref) => (
		<textarea
			data-slot="textarea"
			className={cn(textareaVariants({ size }), className)}
			ref={ref}
			{...props}
		/>
	),
);
Textarea.displayName = "Textarea";

export { Textarea };
